"use client";
import { useAtom } from "jotai";
import { spinnerAtom } from "@/atoms/spinner.atom";
import Spinner from "@/components/ui/spinner";

export function GlobalSpinner() {
  const [show] = useAtom(spinnerAtom);
  return <Spinner show={show} label="Loading..." />;
}
